export default function Logo({ size = 36 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      style={{ flexShrink: 0, display: 'block' }}
    >
      <defs>
        <linearGradient id="sdt-logo-grad" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#1B5E20" />
          <stop offset="50%" stopColor="#43A047" />
          <stop offset="100%" stopColor="#A5D6A7" />
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="43" fill="none" stroke="#DCEDC8" strokeWidth="14" />
      <path d="M50,7 A43,43 0 1,1 10,68" fill="none" stroke="url(#sdt-logo-grad)" strokeWidth="14" strokeLinecap="round" />
      <circle cx="50" cy="50" r="25" fill="#1B5E20" />
      <text x="50" y="58" fontFamily="-apple-system,Arial,sans-serif" fontWeight="900" fontSize="26" fill="white" textAnchor="middle">$</text>
    </svg>
  );
}
